import React, {useEffect, useState} from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {
    getClassificationTypesRequest,
    getUsageTypesRequest
} from "../redux/actions/jointPowersActions";
import {updateContractRequest} from "../redux/actions/contractActions";
import "./ContractDataForm.css";
import '../error.css'
import {apiCall} from "../redux/utils/api";

const ContractDataForm = ({ contract, setCurrentStep, previousStep, submitButtonText }) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
        defaultValues: contract // Setzt die Standardwerte des Formulars auf die aktuellen Mitarbeiterdaten
    });
    const classificationTypes = useSelector(state => state.jointPower.classificationTypes);
    const isLoadingClassificationTypes = useSelector(state => state.jointPower.loading.getClassificationTypes);
    const usageTypes = useSelector(state => state.jointPower.usageTypes);
    const isLoadingUsageTypes = useSelector(state => state.jointPower.loading.getUsageTypes);
    const isUpdatingContract = useSelector(state => state.contract.loading.updateContract);
    const [schoolIdentificationSuggestions, setSchoolIdentificationSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);

    useEffect(() => {
        if (!classificationTypes.length && !isLoadingClassificationTypes) {
            dispatch(getClassificationTypesRequest());
        }
        if (classificationTypes.length > 0) {
            setValue("ClassificationType", contract.ClassificationType);
        }
        if (!usageTypes.length && !isLoadingUsageTypes) {
            dispatch(getUsageTypesRequest());
        }
    }, [dispatch, classificationTypes, usageTypes, contract.ClassificationType, isLoadingClassificationTypes, isLoadingUsageTypes, setValue]);

    const onSubmit = myData => {
        if (!selectedSchool) {
            alert("Bitte eine Schule auswählen!");
            return;
        }
        if (!isUpdatingContract) {
            dispatch(updateContractRequest(myData));
            setCurrentStep();
        }
    }

    const fetchSchoolIdentificationSuggestions = async (inputValue) => {
        if (inputValue.length < 3) { // Um unnötige Anfragen zu vermeiden
            setSchoolIdentificationSuggestions([]);
            return;
        }
        const data = await apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getSchools`, 'POST', {"searchStr": inputValue});
        setSchoolIdentificationSuggestions(data);
        setShowSuggestions(true);
    };

    const onSuggestionClick = (suggestion) => {
        setSelectedSchool(suggestion);
        setValue("SchoolIdentificationNumber", suggestion.SchoolID);
        setSchoolIdentificationSuggestions([]);
    };

    const clearSelectedSchool = () => {
        setSelectedSchool(null);
        setValue("SchoolIdentificationNumber", '');
    };

    const onBlur = () => {
        setTimeout(() => setShowSuggestions(false), 100); // Verzögert das Ausblenden, um Klicks zu ermöglichen
    };


    const contractOrCivil = watch("ContractOrCivil");

    return (
        <>
            <div className="row">
                <div className="col-12" style={{textAlign: "center", marginBottom: "3.5vh"}}>
                    <h2>Beschäftigungsverhältnis</h2>
                </div>
            </div>
            <div className="form-container">
                <form onSubmit={handleSubmit(onSubmit)} className="contract-form">
                    <div className="mb-3 form-field">
                        <label className="form-label">Schulkennzahl der Stammschule</label>
                        <input
                            {...register("SchoolIdentificationNumber", { required: "Schulkennzahl ist erforderlich!" })}
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                                setValue("SchoolIdentificationNumber", e.target.value);
                                fetchSchoolIdentificationSuggestions(e.target.value);
                            }}
                            onBlur={onBlur}
                        />
                        {schoolIdentificationSuggestions.length > 0 && (
                            <ul className="suggestions-list">
                                {schoolIdentificationSuggestions.map((suggestion, index) => (
                                    <li
                                        key={index}
                                        onClick={() => onSuggestionClick(suggestion)}
                                        className="suggestion-item"
                                    >
                                        {`${suggestion.SchoolID} ${suggestion.SchoolName}, ${suggestion.Street}, ${suggestion.PostalCode} ${suggestion.Place}`}
                                    </li>
                                ))}
                            </ul>
                        )}
                        {errors.SchoolIdentificationNumber && (
                            <p className="error-message">{errors.SchoolIdentificationNumber.message}</p>
                        )}
                    </div>

                    {/** Anzeige ausgewählter Schule **/}
                    {selectedSchool && (
                        <div className="selected-school-item">
                            {`${selectedSchool.SchoolID} ${selectedSchool.SchoolName}, ${selectedSchool.Street}, ${selectedSchool.PostalCode} ${selectedSchool.Place}`}
                            <button type="button" className="remove-school-btn" onClick={() => clearSelectedSchool()}>
                                ✖
                            </button>
                        </div>
                    )}
                    <hr/>
                    <div className="mb-3 form-field">
                        <label className="form-label">Dienstverhältnis</label>
                        <select {...register("StateOrFederal", {required: "Ist auszuwählen!"})}
                                className="form-select">
                            <option value="NONE" disabled>Wählen Sie...</option>
                            <option value="FEDERAL">Land</option>
                            <option value="STATE">Bund</option>
                        </select>
                    </div>
                    <hr />
                    <div className="mb-3 form-group">
                        <label htmlFor="ContractOrCivil" className="form-label">Beschäftigungsverhältnis</label>
                        <select {...register("ContractOrCivil", {required: "Feld ist erforderlich!"})}
                                className="form-select">
                            <option value="NONE">Bitte wählen</option>
                            <option value="CONTRACT">vertragsbedienstet</option>
                            <option value="CIVIL">pragmatisiert</option>
                        </select>
                        {errors.ContractOrCivil && <p className="error-message">{errors.ContractOrCivil.message}</p>}
                    </div>
                    {contractOrCivil === "CONTRACT" && (
                        <div className="mb-3 form-group">
                            <label htmlFor="FixedOrPermanent" className="form-label">Vertragstyp</label>
                            <select {...register("FixedOrPermanent", {required: "Vertragstyp ist erforderlich!"})}
                                    className="form-select">
                                <option value="NONE">Bitte wählen</option>
                                <option value="PERMANENT">IL (unbefristet)</option>
                                <option value="FIXED">IIL (befristet)</option>
                            </select>
                        </div>
                    )}
                    {contractOrCivil === "CONTRACT" && (
                        <div className="mb-3 form-group">
                            <label htmlFor="ClassificationType" className="form-label">Einstufung</label>
                            <select {...register("ClassificationType", {required: "Einstufung/Abgeltungstyp ist erforderlich!"})}
                                    className="form-select">
                                <option value="NONE">Bitte wählen</option>
                                {classificationTypes.map((type, index) => (
                                    <option key={index} value={type.value}>{type.label}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    {contractOrCivil === "CIVIL" && (
                        <div className="mb-3 form-group">
                            <label htmlFor="ClassificationType" className="form-label">Einstufung</label>
                            <select {...register("ClassificationType", {required: "Einstufung/Abgeltungstyp ist erforderlich!"})}
                                    className="form-select">
                                <option value="NONE">Bitte wählen</option>
                                {classificationTypes.map((type, index) => (
                                    <option key={index} value={type.value}>{type.label}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="form-navigation-buttons">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={previousStep}
                        >
                            <FaArrowLeft/> Zurück
                        </button>
                        <button type="submit" className="btn btn-primary">{submitButtonText}</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ContractDataForm;
